document.addEventListener("teeinblue-event-component-injected", function () {
  const elementToMove = document.querySelector(".tee-block.tee-product-price");
  const insertAfterElement = document.querySelector(".review-widget");
  if (elementToMove && insertAfterElement) {
    insertAfterElement.after(elementToMove);
  }
});
document.addEventListener("teeinblue-event-component-injected", function () {
  const elementToMove1 = document.querySelector(".product__tax.caption.rte");
  const insertAfterElement1 = document.querySelector(
    ".tee-block.tee-product-price"
  );
  if (elementToMove1 && insertAfterElement1) {
    insertAfterElement1.after(elementToMove1);
  }
});
setInterval(() => {
  const elements = document.querySelectorAll(".product-option");

  elements.forEach((element) => {
    const content = element.textContent || element.innerText;
    if (
      content.includes("Available Product") ||
      content.includes("Grundfarbe") ||
      content.includes("Size")
    ) {
      element.remove();
    }
  });
}, 100);